<script>
    import {imageUrl, getStyleValue} from '../../Common/tools';
    import {External} from "../../external";

    export let data, globalStyle, isChild = false, style = 'padding-left: 40px; padding-right: 10px; text-align: left;';
    const placeholder = External.resources + '/images/marketing/placeholders/139x34.png';

    let align;
    $: {
        if (!data.style.position || data.style.position === '' || data.style.position === 'left') {
            align = 'component-left';
        } else if (data.style.position === 'center') {
            align = 'component-center';
        } else {
            align = 'component-right';
        }
    }
</script>
{#if !isChild}
    <tr valign="top">
        <th class="column column-st" width="{getStyleValue(globalStyle.width, 600)}"
            align={data.style.position || 'left'}>
            <img src={imageUrl(data, placeholder)} class="{align}" style="display: block;"
                 width={getStyleValue(data.style.width, 139)}
                 border="0" alt="">
        </th>
    </tr>
{:else}
    <th class="column mobile-12" style="{style}"
        width="{getStyleValue(data.style.width, 105)}" align={data.style.position || 'left'}>
        <a style="display: inline-block; pointer-events: none;">
            <img class="{align}" src="{imageUrl(data, placeholder)}" alt=""
                style="border: 0; width: 100%; max-width: {getStyleValue(data.style.width, 105)}px;"
                width="{getStyleValue(data.style.width, 105)}">
        </a>
    </th>
{/if}